(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aa-ball-rack-size-visualizer-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-ball-rack-size-visualizer')) {
    customElements.define(
      'aa-ball-rack-size-visualizer',
      class AABallRackSizeVisualizer extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section') || document;
          this.stage = this.querySelector('.aa-ball-rack-visualizer__stage');
          this.depthInches = this.querySelector('[data-aa-ball-depth-inches]');
          this.depthCm = this.querySelector('[data-aa-ball-depth-cm]');
          this.dimensionInches = this.querySelector('[data-aa-ball-dimension-inches]');
          this.dimensionCm = this.querySelector('[data-aa-ball-dimension-cm]');
          this.capacity = this.querySelector('[data-aa-ball-capacity]');

          try {
            this.variants = JSON.parse(this.querySelector('[data-aa-ball-variants]').textContent);
          } catch (error) {
            return;
          }

          this.onVariantInput = (event) => {
            if (!event.target.matches('input[type="radio"]')) return;
            const capacity = Number.parseInt(event.target.value, 10);
            if (![60, 80, 100, 120].includes(capacity)) return;
            this.selectVisualizer();
            requestAnimationFrame(() => this.render());
            window.setTimeout(() => this.render(), 60);
          };

          this.section.addEventListener('input', this.onVariantInput);
          this.section.addEventListener('change', this.onVariantInput);
          this.resizeObserver = new ResizeObserver(() => this.fitToStage());
          this.resizeObserver.observe(this.stage);
          this.fitToStage();
          this.render();
        }

        disconnectedCallback() {
          this.section?.removeEventListener('input', this.onVariantInput);
          this.section?.removeEventListener('change', this.onVariantInput);
          this.resizeObserver?.disconnect();
        }

        selectedVariant() {
          const formVariantInput = this.section.querySelector(
            'form[action*="/cart/add"] input[name="id"]'
          );
          const variantId = Number(formVariantInput?.value || this.dataset.initialVariantId);
          return this.variants.find((variant) => Number(variant.id) === variantId);
        }

        selectVisualizer() {
          const thumb = this.section.querySelector('.aa-ball-rack-visualizer-thumb');
          const gallery = thumb?.closest('hdt-product-media');
          const slider = gallery?.querySelector('.hdt-product-media__main hdt-slider');
          if (!thumb || !slider) return;
          window.setTimeout(() => slider.goToIndex(Number(thumb.value), true), 0);
        }

        updateOutput(output, value) {
          output.value = value;
          output.textContent = value;
        }

        fitToStage() {
          const bodyHeight = Math.min(360, this.stage.clientWidth / 1.7);
          this.stage.style.setProperty('--aa-ball-body-height', `${bodyHeight}px`);
        }

        render() {
          const variant = this.selectedVariant();
          if (!variant) return;

          const capacity = Number.parseInt(variant.option1, 10);
          const sizes = {
            60: { inches: '15.0', cm: '38', ratio: '0.95', middle: '1.30' },
            80: { inches: '18.9', cm: '48', ratio: '1.20', middle: '1.65' },
            100: { inches: '22.8', cm: '58', ratio: '1.45', middle: '2.00' },
            120: { inches: '26.8', cm: '68', ratio: '1.70', middle: '2.35' },
          };
          const size = sizes[capacity];
          if (!size) return;

          this.style.setProperty('--aa-ball-depth-ratio', size.ratio);
          this.style.setProperty('--aa-ball-middle-stretch', size.middle);
          this.updateOutput(this.depthInches, size.inches);
          this.updateOutput(this.depthCm, size.cm);
          this.updateOutput(this.dimensionInches, size.inches);
          this.updateOutput(this.dimensionCm, size.cm);
          this.updateOutput(this.capacity, String(capacity));
        }
      }
    );
  }

  if (!window.aaBallRackVisualizerGalleryReady) {
    window.aaBallRackVisualizerGalleryReady = true;

    const bindBallRackVisualizerThumbs = () => {
      document
        .querySelectorAll('.aa-ball-rack-visualizer-thumb:not([data-aa-bound])')
        .forEach((thumb) => {
          thumb.dataset.aaBound = 'true';
          thumb.addEventListener(
            'click',
            () => {
              const gallery = thumb.closest('hdt-product-media');
              const slider = gallery?.querySelector('.hdt-product-media__main hdt-slider');
              if (slider) slider.goToIndex(Number(thumb.value), true);
            },
            true
          );
        });
    };

    bindBallRackVisualizerThumbs();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindBallRackVisualizerThumbs, { once: true });
    }
    document.addEventListener('shopify:section:load', bindBallRackVisualizerThumbs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-crate-depth-overlay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-crate-depth-overlay')) {
    customElements.define(
      'aa-crate-depth-overlay',
      class AACrateDepthOverlay extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section') || document;
          this.depthInches = this.querySelector('[data-depth-inches]');
          this.depthCm = this.querySelector('[data-depth-cm]');
          this.capacity = this.querySelector('[data-capacity]');
          this.progress = this.querySelector('[data-depth-progress]');

          try {
            this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          } catch (error) {
            return;
          }

          this.onVariantInput = () => {
            requestAnimationFrame(() => {
              this.render();
              window.setTimeout(() => this.render(), 60);
            });
          };

          this.section.addEventListener('input', this.onVariantInput);
          this.section.addEventListener('change', this.onVariantInput);
          this.render();
        }

        disconnectedCallback() {
          this.section?.removeEventListener('input', this.onVariantInput);
          this.section?.removeEventListener('change', this.onVariantInput);
        }

        selectedVariant() {
          const formVariantInput = this.section.querySelector(
            'form[action*="/cart/add"] input[name="id"]'
          );
          const variantId = Number(formVariantInput?.value || this.dataset.initialVariantId);
          return this.variants.find((variant) => Number(variant.id) === variantId);
        }

        render() {
          const variant = this.selectedVariant();
          if (!variant) return;

          const capacity = Number.parseInt(variant.option1, 10);
          const sizes = {
            80: { inches: '16.5', cm: '42', progress: '68%' },
            100: { inches: '20.5', cm: '52', progress: '84%' },
            120: { inches: '24.4', cm: '62', progress: '100%' },
          };
          const size = sizes[capacity];
          if (!size) return;

          this.depthInches.value = size.inches;
          this.depthInches.textContent = size.inches;
          this.depthCm.value = size.cm;
          this.depthCm.textContent = size.cm;
          this.capacity.value = String(capacity);
          this.capacity.textContent = String(capacity);
          this.progress.style.setProperty('--aa-depth-progress', size.progress);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-crate-size-visualizer-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-crate-size-visualizer')) {
    customElements.define(
      'aa-crate-size-visualizer',
      class AACrateSizeVisualizer extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section') || document;
          this.productVisual = this.querySelector('[data-aa-crate-product]');
          this.dimension = this.querySelector('[data-aa-crate-dimension]');
          this.stage = this.querySelector('.aa-crate-size-visualizer__stage');
          this.depthInches = this.querySelector('[data-aa-depth-inches]');
          this.depthCm = this.querySelector('[data-aa-depth-cm]');
          this.dimensionInches = this.querySelector('[data-aa-dimension-inches]');
          this.dimensionCm = this.querySelector('[data-aa-dimension-cm]');
          this.capacity = this.querySelector('[data-aa-capacity]');

          try {
            this.variants = JSON.parse(this.querySelector('[data-aa-crate-variants]').textContent);
          } catch (error) {
            return;
          }

          this.onVariantInput = (event) => {
            if (!event.target.matches('input[type="radio"]')) return;
            const capacity = Number.parseInt(event.target.value, 10);
            if (![80, 100, 120].includes(capacity)) return;
            this.selectVisualizer();
            requestAnimationFrame(() => this.render());
            window.setTimeout(() => this.render(), 60);
          };

          this.section.addEventListener('input', this.onVariantInput);
          this.section.addEventListener('change', this.onVariantInput);
          this.resizeObserver = new ResizeObserver(() => this.fitToStage());
          this.resizeObserver.observe(this.stage);
          this.fitToStage();
          this.render();
        }

        disconnectedCallback() {
          this.section?.removeEventListener('input', this.onVariantInput);
          this.section?.removeEventListener('change', this.onVariantInput);
          this.resizeObserver?.disconnect();
        }

        selectedVariant() {
          const formVariantInput = this.section.querySelector(
            'form[action*="/cart/add"] input[name="id"]'
          );
          const variantId = Number(formVariantInput?.value || this.dataset.initialVariantId);
          return this.variants.find((variant) => Number(variant.id) === variantId);
        }

        selectVisualizer() {
          const thumb = this.section.querySelector('.aa-crate-size-visualizer-thumb');
          const gallery = thumb?.closest('hdt-product-media');
          const slider = gallery?.querySelector('.hdt-product-media__main hdt-slider');
          if (!thumb || !slider) return;
          window.setTimeout(() => slider.goToIndex(Number(thumb.value), true), 0);
        }

        updateOutput(output, value) {
          output.value = value;
          output.textContent = value;
        }

        fitToStage() {
          const bodyHeight = Math.min(370, this.stage.clientWidth / 1.6757);
          this.stage.style.setProperty('--aa-body-height', `${bodyHeight}px`);
        }

        render() {
          const variant = this.selectedVariant();
          if (!variant) return;

          const capacity = Number.parseInt(variant.option1, 10);
          const sizes = {
            80: { inches: '16.5', cm: '42', ratio: '1.1351', middle: '1.155' },
            100: { inches: '20.5', cm: '52', ratio: '1.4054', middle: '1.492' },
            120: { inches: '24.4', cm: '62', ratio: '1.6757', middle: '1.830' },
          };
          const size = sizes[capacity];
          if (!size) return;

          this.style.setProperty('--aa-depth-ratio', size.ratio);
          this.style.setProperty('--aa-middle-stretch', size.middle);
          this.updateOutput(this.depthInches, size.inches);
          this.updateOutput(this.depthCm, size.cm);
          this.updateOutput(this.dimensionInches, size.inches);
          this.updateOutput(this.dimensionCm, size.cm);
          this.updateOutput(this.capacity, String(capacity));
        }
      }
    );
  }

  if (!window.aaCrateSizeVisualizerGalleryReady) {
    window.aaCrateSizeVisualizerGalleryReady = true;

    const bindCrateVisualizerThumbs = () => {
      document
        .querySelectorAll('.aa-crate-size-visualizer-thumb:not([data-aa-bound])')
        .forEach((thumb) => {
          thumb.dataset.aaBound = 'true';
          thumb.addEventListener(
            'click',
            () => {
              const gallery = thumb.closest('hdt-product-media');
              const slider = gallery?.querySelector('.hdt-product-media__main hdt-slider');
              if (slider) slider.goToIndex(Number(thumb.value), true);
            },
            true
          );
        });
    };

    bindCrateVisualizerThumbs();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindCrateVisualizerThumbs, { once: true });
    }
    document.addEventListener('shopify:section:load', bindCrateVisualizerThumbs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-custom-depth-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-custom-depth-request')) {
    customElements.define(
      'aa-custom-depth-request',
      class AACustomDepthRequest extends HTMLElement {
        connectedCallback() {
          this.capacity = this.querySelector('[data-aa-custom-capacity]');
          this.color = this.querySelector('[data-aa-custom-color]');
          this.productUrl = this.querySelector('[data-aa-custom-url]');
          this.onVariantChange = () => this.syncVariant();
          this.onDeliveryChange = (event) => this.syncUnits(event);
          document.addEventListener('input', this.onVariantChange);
          document.addEventListener('change', this.onVariantChange);
          this.querySelectorAll('[data-aa-delivery-country]').forEach((input) => {
            input.addEventListener('change', this.onDeliveryChange);
          });
          this.syncVariant();
        }

        disconnectedCallback() {
          document.removeEventListener('input', this.onVariantChange);
          document.removeEventListener('change', this.onVariantChange);
          this.querySelectorAll('[data-aa-delivery-country]').forEach((input) => {
            input.removeEventListener('change', this.onDeliveryChange);
          });
        }

        syncVariant() {
          const capacity = document.querySelector('input[name="Capacity"]:checked, input[name="Size"]:checked');
          const color = document.querySelector('input[name="Primary color"]:checked');
          if (capacity) this.capacity.value = capacity.value;
          if (color) this.color.value = color.value;
          this.productUrl.value = window.location.href;
        }

        syncUnits(event) {
          const countryCode = event.currentTarget.dataset.aaDeliveryCountry;
          const unit = countryCode === 'CA' ? 'cm' : 'in';
          const unitInput = this.querySelector(`input[name="contact[Depth unit]"][value="${unit}"]`);
          if (unitInput) unitInput.checked = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-custom-product-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-custom-product-request')) {
    customElements.define(
      'aa-custom-product-request',
      class AACustomProductRequest extends HTMLElement {
        connectedCallback() {
          this.variantTitle = this.querySelector('[data-aa-custom-variant-title]');
          this.variantId = this.querySelector('[data-aa-custom-variant-id]');
          this.productUrl = this.querySelector('[data-aa-custom-url]');
          this.variants = JSON.parse(this.dataset.variants || '[]');
          this.onVariantChange = () => this.syncVariant();
          document.addEventListener('input', this.onVariantChange);
          document.addEventListener('change', this.onVariantChange);
          this.syncVariant();
        }

        disconnectedCallback() {
          document.removeEventListener('input', this.onVariantChange);
          document.removeEventListener('change', this.onVariantChange);
        }

        syncVariant() {
          const productForm = document.querySelector('form[action*="/cart/add"]');
          const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
          const variantId = variantInput ? String(variantInput.value) : this.variantId.value;
          const variant = this.variants.find((item) => String(item.id) === variantId);
          this.variantId.value = variantId;
          if (variant) this.variantTitle.value = variant.title;
          this.productUrl.value = window.location.href;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-market-suggestion"] && !Shopify.designMode) return;
  try {
    (() => {
    const preferenceKey = 'aa_market_country_preference_v1';
    const dismissalKey = 'aa_market_suggestion_dismissal_v1';
    const preferenceLifetime = 180 * 24 * 60 * 60 * 1000;
    const dismissalLifetime = 30 * 24 * 60 * 60 * 1000;

    const readStorage = (key) => {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch (error) {
        return null;
      }
    };

    const writeStorage = (key, value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        return;
      }
    };

    const removeStorage = (key) => {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        return;
      }
    };

    const rememberPreference = (country) => {
      if (!country) return;
      writeStorage(preferenceKey, {
        country,
        expiresAt: Date.now() + preferenceLifetime
      });
    };

    const hideSuggestion = (panel) => {
      panel.classList.remove('is-visible');
      window.setTimeout(() => {
        panel.hidden = true;
      }, 180);
    };

    // AA 2026-09-26: never show this notice on top of Shopify's cookie banner.
    // In regions where the banner is required, wait until the visitor answers it.
    const waitForCustomerPrivacy = () => new Promise((resolve) => {
      let tries = 0;
      const tick = () => {
        const api = window.Shopify && window.Shopify.customerPrivacy;
        if (api || tries >= 50) return resolve(api || null);
        tries += 1;
        window.setTimeout(tick, 100);
      };
      tick();
    });

    const consentAnswerPending = (api) => {
      try {
        if (!api || typeof api.shouldShowBanner !== 'function' || !api.shouldShowBanner()) return false;
        return typeof api.getTrackingConsent === 'function' && api.getTrackingConsent() === 'no_interaction';
      } catch (error) {
        return false;
      }
    };

    const waitForConsentAnswer = async () => {
      const api = await waitForCustomerPrivacy();
      if (api) {
        if (!consentAnswerPending(api)) return;
        await new Promise((resolve) => {
          document.addEventListener('visitorConsentCollected', () => resolve(), { once: true });
        });
        await new Promise((resolve) => window.setTimeout(resolve, 400));
        return;
      }
      const banner = document.getElementById('shopify-pc__banner');
      if (!banner || getComputedStyle(banner).display === 'none') return;
      await new Promise((resolve) => {
        const timer = window.setInterval(() => {
          if (!banner.isConnected || getComputedStyle(banner).display === 'none') {
            window.clearInterval(timer);
            resolve();
          }
        }, 500);
      });
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      const submittedCountry =
        event.submitter && event.submitter.name === 'country_code'
          ? event.submitter.value
          : form.querySelector('[name="country_code"]')?.value;

      rememberPreference(submittedCountry);
    }, true);

    const initializeMarketSuggestion = async () => {
      const panels = Array.from(document.querySelectorAll('[data-aa-market-suggestion]'));
      if (panels.length === 0) return;

      const now = Date.now();
      const preference = readStorage(preferenceKey);
      if (preference && preference.expiresAt > now) return;
      if (preference) removeStorage(preferenceKey);

      const currentCountry = panels[0].dataset.currentCountry;
      if (!currentCountry || !window.Shopify?.routes?.root) return;

      const query =
        'browsing_context_suggestions.json?country[enabled]=true&country[exclude]='
        + encodeURIComponent(currentCountry);

      try {
        const response = await fetch(window.Shopify.routes.root + query, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) return;

        const data = await response.json();
        const targetCountry = data.suggestions?.[0]?.parts?.country?.handle;
        if (!targetCountry || targetCountry === currentCountry) return;

        const latestPreference = readStorage(preferenceKey);
        if (latestPreference && latestPreference.expiresAt > Date.now()) return;

        const dismissal = readStorage(dismissalKey);
        if (
          dismissal
          && dismissal.currentCountry === currentCountry
          && dismissal.targetCountry === targetCountry
          && dismissal.expiresAt > Date.now()
        ) {
          return;
        }
        if (dismissal) removeStorage(dismissalKey);

        const panel = panels.find((item) => item.dataset.targetCountry === targetCountry);
        if (!panel) return;

        await waitForConsentAnswer();
        const preferenceAfterConsent = readStorage(preferenceKey);
        if (preferenceAfterConsent && preferenceAfterConsent.expiresAt > Date.now()) return;

        panel.querySelector('[data-aa-market-close]')?.addEventListener('click', () => {
          writeStorage(dismissalKey, {
            currentCountry,
            targetCountry,
            expiresAt: Date.now() + dismissalLifetime
          });
          hideSuggestion(panel);
        });

        panel.querySelector('[data-aa-market-keep]')?.addEventListener('click', (event) => {
          rememberPreference(event.currentTarget.dataset.currentCountry);
          hideSuggestion(panel);
        });

        panel.hidden = false;
        window.requestAnimationFrame(() => {
          panel.classList.add('is-visible');
        });
      } catch (error) {
        return;
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeMarketSuggestion, { once: true });
    } else {
      initializeMarketSuggestion();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-priority-product-faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', event => {
    const summary = event.target.closest('.aa-product-faq__item > summary');

    if (!summary || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    event.preventDefault();
    summary.parentElement.open = !summary.parentElement.open;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-product-proof-icons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-product-proof')) {
    customElements.define(
      'aa-product-proof',
      class AAProductProof extends HTMLElement {
        connectedCallback() {
          this.loadOutput = this.querySelector('[data-aa-proof-load]');
          this.assemblyOutput = this.querySelector('[data-aa-proof-assembly]');
          this.assemblyDetail = this.querySelector('[data-aa-proof-assembly-detail]');
          this.productArea = this.closest('.hdt-main-product') || document;
          this.picker = this.productArea.querySelector('hdt-variant-picker');
          this.onVariantChange = () => setTimeout(() => this.update(), 0);
          this.picker?.addEventListener('change', this.onVariantChange);
          this.update();
          this.syncTimers = [50, 150, 300].map((delay) =>
            setTimeout(() => this.update(), delay)
          );
        }

        disconnectedCallback() {
          this.picker?.removeEventListener('change', this.onVariantChange);
          this.syncTimers?.forEach((timer) => clearTimeout(timer));
        }

        selectedValue(optionName) {
          if (!optionName || !this.picker) return '';
          return (
            this.picker.querySelector(
              `input[name="${CSS.escape(optionName)}"]:checked`
            )?.value || ''
          );
        }

        capacityFromOptions() {
          if (!this.picker) return 0;
          const values = [
            ...Array.from(this.picker.querySelectorAll('input:checked'), (el) => el.value),
            ...Array.from(this.picker.querySelectorAll('select'), (el) => el.value),
          ];
          for (const value of values) {
            if (!/record|LP/.test(value || '')) continue;
            const match = /(\d+)/.exec(value);
            if (match) return Number.parseInt(match[1], 10);
          }
          return 0;
        }

        update() {
          const handle = this.dataset.productHandle;
          let capacity = 0;
          let width = 0;

          if (handle === 'three-tier-metal-vinyl-record-stand-3romb') {
            width = Number.parseFloat(this.selectedValue(this.dataset.widthOption));
            capacity = width * 15;
          } else {
            capacity = this.capacityFromOptions();
          }

          if (Number.isFinite(capacity) && capacity > 0 && this.loadOutput) {
            const lpKg = Number.parseFloat(this.dataset.lpKg) || 0.3;
            const lpLb = Number.parseFloat(this.dataset.lpLb) || 0.66;
            const kg = Math.round(capacity * lpKg * 10) / 10;
            const lb = Math.round((capacity * lpLb) / 5) * 5;
            const kgText = Number.isInteger(kg) ? String(kg) : kg.toFixed(1);
            this.loadOutput.textContent = this.dataset.loadTemplate
              .replace('[capacity]', String(capacity))
              .replace('[kg]', kgText)
              .replace('[lb]', String(lb));
          }

          if (!this.assemblyOutput || !this.assemblyDetail) return;

          if (handle === 'three-tier-metal-vinyl-record-stand-3romb' && width > 0) {
            const shipsInTwoParts = width * 25.4 > 600;
            this.assemblyOutput.textContent = shipsInTwoParts
              ? this.dataset.twoPartLabel
              : this.dataset.onePieceLabel;
            this.assemblyDetail.textContent = shipsInTwoParts
              ? this.dataset.twoPartDetail
              : this.dataset.assembledDetail;
          } else if (handle === 'triple-deck-vinyl-record-storage-cart' && capacity > 0) {
            const shipsInSections = capacity > 180;
            this.assemblyOutput.textContent = shipsInSections
              ? this.dataset.weldedSectionsLabel
              : this.dataset.onePieceLabel;
            this.assemblyDetail.textContent = shipsInSections
              ? this.dataset.simpleAssemblyDetail
              : this.dataset.assembledDetail;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-width-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-width-configurator')) {
      customElements.define(
        'aa-width-configurator',
        class AAWidthConfigurator extends HTMLElement {
          connectedCallback() {
            this.widths =
              this.dataset.widthMode === 'one-inch'
                ? Array.from({ length: 13 }, (_, index) => {
                    const width = 12 + index;
                    return {
                      width,
                      capacity: String(width * 15),
                      optionValue: String(width)
                    };
                  })
                : [
                    { width: 12, capacity: '180', optionValue: '180' },
                    { width: 16, capacity: '240', optionValue: '240' },
                    { width: 20, capacity: '300', optionValue: '300' },
                    { width: 24, capacity: '360', optionValue: '360' }
                  ];
            this.range = this.querySelector('[data-width-range]');
            this.widthOutput = this.querySelector('[data-width-output]');
            this.dimensionOutput = this.querySelector('[data-dimension-output]');
            this.capacityOutput = this.querySelector('[data-capacity-output]');
            this.priceOutput = this.querySelector('[data-price-output]');
            this.comparePriceOutput = this.querySelector('[data-compare-price-output]');
            this.savingOutput = this.querySelector('[data-saving-output]');
            this.assemblyNote = this.querySelector('[data-assembly-note]');
            this.status = this.querySelector('[data-status]');
            this.stand = this.querySelector('[data-stand]');
            this.section = this.closest('.shopify-section') || document;

            try {
              this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
            } catch (error) {
              return;
            }

            this.initialize();
          }

          initialize(attempt = 0) {
            const capacityInput = this.capacityInputs()[0];
            const discoveredFormId =
              this.dataset.productFormId ||
              capacityInput?.getAttribute('form') ||
              this.section.querySelector('hdt-variant-picker[form]')?.getAttribute('form');
            this.form = discoveredFormId ? document.getElementById(discoveredFormId) : null;

            if ((!this.form || !capacityInput) && attempt < 60) {
              requestAnimationFrame(() => this.initialize(attempt + 1));
              return;
            }

            this.addWidthProperty();
            this.hideCapacityPicker();
            this.syncFromVariant();
            this.range.addEventListener('input', () => this.selectWidth());
            this.section.addEventListener('change', (event) => {
              if (event.target !== this.range) requestAnimationFrame(() => this.render());
            });
          }

          capacityInputs() {
            return Array.from(
              this.section.querySelectorAll(
                `input[name="${CSS.escape(this.dataset.capacityOptionName)}"]`
              )
            );
          }

          currentFinish() {
            return this.section.querySelector('input[name="Primary color"]:checked')?.value;
          }

          selectedVariant() {
            const selected = this.widths[Number(this.range.value)];
            const finish = this.currentFinish();

            return this.variants.find(
              (variant) =>
                variant.options[0] === selected.optionValue &&
                variant.options[1] === finish
            );
          }

          selectWidth() {
            const selected = this.widths[Number(this.range.value)];
            const capacityInput = this.capacityInputs().find(
              (input) => input.value === selected.optionValue
            );

            if (capacityInput && !capacityInput.checked) {
              capacityInput.click();
            }

            this.render();
          }

          syncFromVariant() {
            const capacity = this.capacityInputs().find((input) => input.checked)?.value;
            const index = this.widths.findIndex((entry) => entry.optionValue === capacity);
            this.range.value = String(index >= 0 ? index : 0);
            this.render();
          }

          render() {
            const selected = this.widths[Number(this.range.value)];
            const variant = this.selectedVariant();
            const requiresAssembly = selected.width * 25.4 >= 600;

            this.widthOutput.value = String(selected.width);
            this.widthOutput.textContent = String(selected.width);
            this.dimensionOutput.value = String(selected.width);
            this.dimensionOutput.textContent = String(selected.width);
            this.capacityOutput.value = selected.capacity;
            this.capacityOutput.textContent = selected.capacity;
            this.assemblyNote.hidden = !requiresAssembly;
            this.stand.style.width = `${Math.round(350 * ((selected.width * 25.4) / 1254))}px`;

            if (this.widthProperty) this.widthProperty.value = `${selected.width} inches`;
            if (!variant) return;

            this.priceOutput.textContent = this.money(variant.price);
            this.status.hidden = variant.available;
            this.syncFormVariant(variant);

            if (variant.compare_at_price > variant.price) {
              this.comparePriceOutput.hidden = false;
              this.savingOutput.hidden = false;
              this.comparePriceOutput.textContent = this.money(variant.compare_at_price);
              this.savingOutput.textContent =
                `${this.dataset.saveLabel} ${this.money(
                  variant.compare_at_price - variant.price
                )}`;
            } else {
              this.comparePriceOutput.hidden = true;
              this.savingOutput.hidden = true;
            }
          }

          syncFormVariant(variant) {
            const variantInput = this.form?.querySelector('input[name="id"]');
            const quantityPrice = this.form?.querySelector('hdt-qty-price');
            const buttonMoney = quantityPrice?.querySelector('.hdt-money');

            if (quantityPrice) {
              quantityPrice.setAttribute('variant-price', String(variant.price));
            }
            if (buttonMoney) {
              buttonMoney.textContent = this.money(variant.price);
            }
            if (!variantInput || String(variantInput.value) === String(variant.id)) return;

            variantInput.value = variant.id;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          money(cents) {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: this.dataset.currency
            }).format(cents / 100);
          }

          addWidthProperty() {
            if (!this.form) return;
            this.widthProperty = this.form.querySelector('input[name="properties[Width]"]');

            if (!this.widthProperty) {
              this.widthProperty = document.createElement('input');
              this.widthProperty.type = 'hidden';
              this.widthProperty.name = 'properties[Width]';
              this.form.appendChild(this.widthProperty);
            }
          }

          hideCapacityPicker() {
            const fieldset = this.capacityInputs()[0]?.closest('fieldset');
            if (!fieldset) return;
            fieldset.hidden = true;
            fieldset.setAttribute('aria-hidden', 'true');
          }
        }
      );
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-width-visualizer-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-width-visualizer')) {
    customElements.define(
      'aa-width-visualizer',
      class AAWidthVisualizer extends HTMLElement {
        connectedCallback() {
          this.stand = this.querySelector('[data-aa-visual-stand]');
          this.art = this.querySelector('[data-aa-visual-art]');
          this.output = this.querySelector('[data-aa-visual-width]');
          this.stage = this.querySelector('.aa-width-visualizer__stage');
          this.isTwoTier = this.hasAttribute('data-two-tier');
          this.isOneTier = this.hasAttribute('data-one-tier');
          this.section = this.closest('.shopify-section') || document;
          this.onInput = (event) => {
            if (event.target.matches('[data-aa-range], input[type="radio"]')) {
              requestAnimationFrame(() => this.render());
            }
          };

          this.section.addEventListener('input', this.onInput);
          this.section.addEventListener('change', this.onInput);
          this.resizeObserver = new ResizeObserver(() => this.render());
          if (this.stage) this.resizeObserver.observe(this.stage);
          this.initialize();
        }

        disconnectedCallback() {
          this.section?.removeEventListener('input', this.onInput);
          this.section?.removeEventListener('change', this.onInput);
          this.resizeObserver?.disconnect();
        }

        initialize(attempt = 0) {
          this.range = this.section.querySelector('[data-aa-range]');
          if (!this.range && attempt < 120) {
            requestAnimationFrame(() => this.initialize(attempt + 1));
            return;
          }
          this.render();
        }

        render() {
          const width = Number(this.range?.value || 12);
          const artHeight =
            Number(this.dataset.artHeight) ||
            (window.matchMedia('(max-width: 749px)').matches ? 465 : 485);
          const standHeight = this.stand.clientHeight || 520;
          const usesSquareArt = this.isTwoTier || this.isOneTier;
          const stageWidth = this.stage?.clientWidth || artHeight;
          let displayedArtHeight = artHeight;
          let maxWidth = usesSquareArt
            ? Math.min(artHeight * 0.775, stageWidth)
            : artHeight * ((24 * 25.4) / 1254);
          let calibratedArtWidth = usesSquareArt
            ? artHeight
            : maxWidth * 1.155;
          let currentWidth = usesSquareArt
            ? maxWidth * (width / 24)
            : artHeight * ((width * 25.4) / 1254);

          if (this.isOneTier) {
            const loadedHeightInches = 49 / 2.54;
            const sourceWidthFraction = 0.94;
            const sourceHeightFraction = 0.855;
            const canvasRatio =
              (24 / loadedHeightInches) * (sourceHeightFraction / sourceWidthFraction);
            displayedArtHeight = Math.min(artHeight, stageWidth / canvasRatio);
            maxWidth = displayedArtHeight * canvasRatio;
            currentWidth = maxWidth * (width / 24);
            calibratedArtWidth = currentWidth;
          }

          const standWidth = `${Math.round(currentWidth)}px`;
          const displayedArtWidth = this.isOneTier ? currentWidth : calibratedArtWidth;
          const artWidth = `${Math.round(displayedArtWidth)}px`;
          const artDisplayHeight = `${Math.round(displayedArtHeight)}px`;
          const backgroundSize =
            `${Math.round(displayedArtWidth)}px ${Math.round(displayedArtHeight)}px`;
          if (this.stand.style.width !== standWidth) this.stand.style.width = standWidth;
          if (this.art.style.width !== artWidth) this.art.style.width = artWidth;
          if (this.isOneTier) {
            const artTop = Math.max(0, (standHeight - 35 - displayedArtHeight) / 2);
            this.art.style.height = artDisplayHeight;
            this.art.style.top = `${Math.round(artTop)}px`;
          }
          if (this.art.style.backgroundSize !== backgroundSize) {
            this.art.style.backgroundSize = backgroundSize;
          }
          this.output.value = String(width);
          this.output.textContent = String(width);
          this.style.setProperty('--aa-visual-stand-height', `${standHeight}px`);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeThumbnailRail = (scope = document) => {
      scope.querySelectorAll('.hdt-product-media__thumb').forEach((rail) => {
        if (rail.dataset.aaThumbRailReady === 'true') return;

        const slider = rail.querySelector('hdt-slider-thumb');
        const previousButton = rail.querySelector('[data-aa-thumb-rail-nav="previous"]');
        const nextButton = rail.querySelector('[data-aa-thumb-rail-nav="next"]');
        if (!slider || !previousButton || !nextButton) return;

        rail.dataset.aaThumbRailReady = 'true';
        let currentIndex = 0;
        let lastWheelMove = 0;

        const slides = () => Array.from(slider.querySelectorAll('.hdt-slider__slide:not([hidden])'));
        const lastIndex = () => Math.max(0, slides().length - 1);

        const updateButtons = () => {
          const end = lastIndex();
          currentIndex = Math.min(Math.max(currentIndex, 0), end);
          previousButton.disabled = currentIndex <= 0;
          nextButton.disabled = currentIndex >= end;
        };

        const syncWithSelectedThumbnail = () => {
          const items = slides();
          const selected = slider.querySelector('.is-thumb-selected');
          const selectedIndex = selected ? items.indexOf(selected) : -1;
          if (selectedIndex >= 0) currentIndex = selectedIndex;
          updateButtons();
        };

        const goTo = (index) => {
          const targetIndex = Math.min(Math.max(index, 0), lastIndex());
          if (targetIndex === currentIndex || typeof slider.goToIndex !== 'function') return;

          currentIndex = targetIndex;
          slider.goToIndex(targetIndex);
          updateButtons();
        };

        previousButton.addEventListener('click', () => goTo(currentIndex - 1));
        nextButton.addEventListener('click', () => goTo(currentIndex + 1));

        slider.addEventListener('click', (event) => {
          const slide = event.target.closest('.hdt-slider__slide');
          if (!slide) return;

          const clickedIndex = slides().indexOf(slide);
          if (clickedIndex >= 0) currentIndex = clickedIndex;
          updateButtons();
        });

        const mainSlider = document.getElementById(slider.getAttribute('aria-controls'));
        mainSlider?.addEventListener('select:slide', () => requestAnimationFrame(syncWithSelectedThumbnail));

        slider.addEventListener('wheel', (event) => {
          if (window.innerWidth < 1150 || event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

          const direction = event.deltaY > 0 ? 1 : -1;
          const atBoundary = direction < 0 ? currentIndex <= 0 : currentIndex >= lastIndex();
          if (atBoundary) return;

          event.preventDefault();
          const now = performance.now();
          if (now - lastWheelMove < 140) return;

          lastWheelMove = now;
          goTo(currentIndex + direction);
        }, { passive: false });

        new MutationObserver(syncWithSelectedThumbnail).observe(slider, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'hidden']
        });

        syncWithSelectedThumbnail();
      });
    };

    const start = () => customElements.whenDefined('hdt-slider-thumb').then(() => initializeThumbnailRail());

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => initializeThumbnailRail(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
